import Vuex from 'vuex';
import savedItineraries from './modules/saved_itineraries';
import searchParams from './modules/search_params';

export default new Vuex.Store({
    modules: {
        savedItineraries,
        searchParams
    }
});